import React, { Component, useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

import machines from "../../../../api/MachinesData";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { EquipementData } from "../../../../api/EquipementData";

const settings = {
  dots: false,
  arrows: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ProjectSection = (props) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    let newProducts = [];
    EquipementData.map((equipement) => {
      equipement.products.map((product) => {
        newProducts.push({
          ...product,
          productId: equipement.id,
          route: `/equipement/${equipement.id}/details/${product.id}`,
        });
      });
    });
    console.log(newProducts);
    // suffle the products
    newProducts = newProducts.sort((a, b) => 0.5 - Math.random());
    setData(newProducts);
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`wpo-project-area ${props.pClass}`}>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="wpo-project-wrap project-active owl-carousel">
            <Slider {...settings}>
              {data.map((data) => (
                <div className="wpo-project-item" key={data.id}>
                  <div className="wpo-project-img" style={{ height: 380 }}>
                    <img src={data.image} alt="" />
                    <div className="left-border"></div>
                    <div className="right-border"></div>
                  </div>
                  <div className="wpo-project-text">
                    <h2>
                      <NavLink onClick={ClickHandler} to={data.route}>
                        {data.name}
                      </NavLink>
                    </h2>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSection;
